import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-[#3A3A2E] text-[#F2EDE4] py-12 px-4 mt-auto" data-id="element-268">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8 text-center md:text-left" data-id="element-269">
        <div className="space-y-2" data-id="element-270">
          <h3 className="font-serif text-xl text-[#7C8062]" data-id="element-271">
            Top Notch Bakery
          </h3>
          <p className="text-sm opacity-80" data-id="element-272">Est. 2021</p>
        </div>

        <div className="flex flex-col gap-3 text-sm opacity-90" data-id="element-273">
          <a href="https://maps.google.com/?q=Klostergatan+7,+Växjö" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center md:justify-start gap-2 hover:text-[#7C8062] transition-colors" data-id="element-274">
            <MapPinIcon className="h-4 w-4 text-[#7C8062]" data-id="element-275" />
            <span data-id="element-276">Klostergatan 7, Växjö</span>
          </a>
          <div className="flex items-center justify-center md:justify-start gap-2" data-id="element-277">
            <PhoneIcon className="h-4 w-4 text-[#7C8062]" data-id="element-278" />
            <span data-id="element-279">0470-52 36 03</span>
          </div>
          <a href="mailto:order@topnotchbakery.se" className="flex items-center justify-center md:justify-start gap-2 hover:text-[#7C8062] transition-colors" data-id="element-280">
            <MailIcon className="h-4 w-4 text-[#7C8062]" data-id="element-281" />
            <span data-id="element-282">order@topnotchbakery.se</span>
          </a>
        </div>

        <div className="text-xs opacity-50" data-id="element-283">
          &copy; {new Date().getFullYear()} Top Notch Bakery.
        </div>
      </div>
    </footer>;
}